import accounts from "./accounts"
import app from "./app"
import auth from "./auth"
import ads from "./ads"
import audiences from "./audiences"
import audiencesTemplates from "./audiences-templates"
import enumerations from "./enumerations"
import media from "./media"
import notification from "./notification"
import pages from "./pages"
import pixels from "./pixels"
import smartAudiences from "./smart-audiences"
import targeting from "./targeting"

export default {
  accounts,
  app,
  auth,
  ads,
  audiences,
  audiencesTemplates,
  enumerations,
  media,
  notification,
  pages,
  pixels,
  smartAudiences,
  targeting,
}
